import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import * as Actions from 'flex/Actions';
import { useAppSelector } from 'flex/utils';

type TenantSettingsState = {
    isLoading: boolean;
    payload: any;
};

export const useViewAdminUserManagement = () => {
    const [state, setState] = useState<TenantSettingsState>({
        isLoading: false,
        payload: null,
    });

    const tenantSettingControlViewConnection = useAppSelector(
        (state) => state.tenantSettingControlViewConnection,
    );
    const tenantSettingViewConnection = useAppSelector(
        (state) => state.tenantSettingViewConnection,
    );

    const dispatch = useDispatch();

    useEffect(() => {
        const { meta, payload } = tenantSettingControlViewConnection;

        // 通信中でない === 画面遷移など意図しないタイミング
        if (!state.isLoading) return;

        switch (meta.status) {
            case Actions.statusEnum.SUCCESS: {
                setState((state) => ({
                    ...state,
                    isLoading: false,
                    payload: payload,
                }));
                return;
            }
            case Actions.statusEnum.FAILURE:
            case Actions.statusEnum.ERROR: {
                setState((state) => ({
                    ...state,
                    isLoading: false,
                }));
                return;
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tenantSettingControlViewConnection]);

    useEffect(() => {
        const { meta, payload } = tenantSettingViewConnection;

        // 通信中でない === 画面遷移など意図しないタイミング
        if (!state.isLoading) return;

        switch (meta.status) {
            case Actions.statusEnum.SUCCESS: {
                setState((state) => ({
                    ...state,
                    isLoading: false,
                    payload: payload,
                }));
                return;
            }
            case Actions.statusEnum.FAILURE:
            case Actions.statusEnum.ERROR: {
                setState((state) => ({
                    ...state,
                    isLoading: false,
                }));
                return;
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tenantSettingViewConnection]);

    const request = useCallback(
        (isControllableUser= false) => {
            isControllableUser
                ? dispatch(Actions.http.connection.tenantSetting.controlView())
                : dispatch(Actions.http.connection.tenantSetting.view());

            setState((state) => ({
                ...state,
                isLoading: true,
            }));
        },
        [dispatch],
    );

    const reset = useCallback(() => {
        setState((state) => ({
            ...state,
            isLoading: false,
        }));
    }, []);

    return [state, request, reset] as const;
};
